import { createFileRoute, redirect } from '@tanstack/react-router'

// Legacy redirect — the standalone create page was folded into the
// master-detail hierarchy editor's "Add" affordance at `/$org/contract-types`
// (spec 2026-08-01-22). Kept so old bookmarks/deep links keep working.
export const Route = createFileRoute('/$org/contract-types/create')({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/$org/contract-types',
            params: { org: params.org },
        })
    },
})
